export class SigninFieldsRequest {
  public PageNumber: number;
  public Width?: string;
  public Height?: string;
  public Left?: string;
  public Top?: string;
  public Label?: string;
}
